<template>
  <svg
    version="1.1"
    viewBox="0 0 256 371"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    style="background-color: #eef1f2"
  >
    <rect height="371" width="256" x="0" y="0" fill="#EEF1F2"></rect>
    <path
      d="M142.40625,0 L142.40625,13.5625 L20.34375,13.5625 C16.5983809,13.5625 13.5625,16.5983809
      13.5625,20.34375 L13.5625,20.34375 L13.5625,159.969687 L76.628125,96.971875
      C79.2732363,94.3424453 83.5445762,94.3424453 86.1896875,96.971875 L86.1896875,96.971875
      L128.84375,139.625937 L164.784375,103.753125 C167.429486,101.123695 171.700826,101.123695
      174.345938,103.753125 L174.345938,103.753125 L203.4375,132.844687 L203.4375,81.375 L217,81.375
       L217,196.65625 C217,207.891934 207.891934,217 196.65625,217 L196.65625,217 L20.34375,217
       C9.10806641,217 0,207.891934 0,196.65625 L0,196.65625 L0,20.34375 C0,9.10806641 9.10806641,0
       20.34375,0 L20.34375,0 L142.40625,0 Z M62,37 C73.045625,37 82,45.954375 82,57 C82,68.045625
       73.045625,77 62,77 C50.954375,77 42,68.045625 42,57 C42,45.954375 50.954375,37 62,37 Z
       M211.783582,5.21641753 C213.066298,6.49913292 213.112109,8.55036201 211.921016,9.88797123
       L211.783582,10.0335825 L191.317,30.5 L211.783582,50.9664175 C213.113806,52.2966409
       213.113806,54.4533591 211.783582,55.7835825 C210.500867,57.0662979 208.449638,57.1121091
       207.112029,55.9210163 L206.966418,55.7835825 L186.5,35.317 L166.033582,55.7835825
       C164.703359,57.1138058 162.546641,57.1138058 161.216418,55.7835825 C159.933702,54.5008671
       159.887891,52.449638 161.078984,51.1120288 L161.216418,50.9664175 L181.683,30.5
       L161.216418,10.0335825 C159.886194,8.7033591 159.886194,6.5466409 161.216418,5.21641753
       C162.499133,3.93370214 164.550362,3.88789087 165.887971,5.07898373 L166.033582,5.21641753
       L186.5,25.683 L206.966418,5.21641753 C208.296641,3.88619416 210.453359,3.88619416
       211.783582,5.21641753 Z"
      fill="#DBE2E5"
      fill-rule="nonzero"
      transform="translate(20.000000, 77.000000)"
    ></path>
  </svg>
</template>
